//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import LikeComponent from "../common/LikeComponent";
import LikeCommentShare from "~/components/video/LikeCommentShare.vue";
import CommentsForm from "../video/CommentsForm.vue";
import {ObserveVisibility} from "vue-observe-visibility";
import SitisImg from '../../node_modules/sitis-nuxt/components/sitis-img/SitisImg.vue'

export default Vue.extend({
  name: "ArticleModal",

  props: ["article", "route", "isShowDurationAction", "replaceUrlPath", "cancelNextArticles"],
  data: function () {
    return {
      articles: [],
      currentUrl: "",

      isLoadNextArticle: false,
      isUpdateRouteScroll: false,

      timeOutScroll: null,
    };
  },

  components: {
    LikeCommentShare,
    CommentsForm,
    LikeComponent,
    SitisImg
  },

  directives: {
    ObserveVisibility,
  },

  created() {
    this.articles = [this.article];
    this.currentUrl = this.$route.path;
    if (!!this.article.replaceUrl && process.client) {
      window.history.replaceState(null, null, this.article.replaceUrl);
    }
  },
  async mounted() {
    this.$modal.show("article-modal");
    this.isGetNextArticle = true;
  },

  computed: {
    isShowBtn() {
      const isShowTopButton = this.article?.button_align === 'top' || this.article?.button_align === "";
      const isShowBottomButton = this.article?.button_align === 'bottom' || this.article?.button_align === "";

      return {
        isShowTopButton,
        isShowBottomButton
      }
    },
    checkPromotion() {
      return this.getCategoryName === "Акция" || this.getCategoryName === "promotions";
    },

    getCategoryName() {
      if (!this.article?.category) {
        return "";
      }
      return (
        this.article?.category?.name ||
        this.article?.category_name?.categoryName ||
        this.article?.apiRoute ||
        ""
      );
    },

    getModel() {
      return this.article?.apiRoute || this.article?.category?.slug;
    },

    customReplceMainPath: function () {
      if (!this.replaceUrlPath) {
        return "stat"
      }
      return this.replaceUrlPath
    },
    modelLikeComponent: function () {
      if (this.article.apiRoute ==='news') {
        return "News"
      }
      if (this.article.apiRoute ==='charity') {
        return "Charity"
      }

      return 'Article'
    },
    linkCharity: function () {
      return this.$store.state.appState?.vars?.['Ссылка на подборку товаров благотворительности'] || ""
    },



    articleButtonStatus: function () {
      return Boolean(Number.parseFloat(this.article.button_status || "0"))
    }
  },

  methods: {
    convertTimestampToDate(timestamp) {
      if (timestamp) {
        return new Date(timestamp * 1000).toLocaleDateString("ru", {
          day: '2-digit',
          month: "numeric",
          year: 'numeric'
        });
      }
      return '';
    },

    close: function () {
      if (!process.client) {
        return
      }

      const currentUrl = this.currentUrl;
      const replaceUrl = this.article.replaceUrl;

      if (this.$route.path.indexOf(`/${this.customReplceMainPath}`) > -1) {
        if (currentUrl !== replaceUrl && replaceUrl) {
          window.history.replaceState(null, null, this.currentUrl);
        } else {
          const url = [
            this.customReplceMainPath,
            this.article?.category?.slug || ""
          ].filter((t) => !!t).join("/")

          this.$router.replace(`/${url}`);
        }
      }

      document.getElementById("article-modal").onscroll = null;
      this.$emit("close");
    },

    // Форматирование начала и окончания акции
    durationAction: function (article) {
      if (!this.isShowDurationAction) {
        return "";
      }

      const isDifferentYears = Boolean(
        this.$moment(article.started_at * 1000).format("YYYY") !==
        this.$moment(article.ended_at * 1000).format("YYYY")
      );

      return `С ${this.$moment(article.started_at * 1000).format(
        isDifferentYears ? "DD MMMM YYYY" : "DD MMMM"
      )} по ${this.$moment(article.ended_at * 1000).format("DD MMMM YYYY")}`;
    },

    // ЛОГИКА ЛЕНИВОЙ ЗАГРУЗКИ
    setEventModalScroll: async function () {
      if (this.cancelNextArticles) {
        return
      }


      document.getElementById("article-modal").onscroll = this.containerScroll;

      const heightScreen =
        document.getElementById("article-modal")?.clientHeight || 0;
      const heightContainer =
        document.getElementById("article-modal-height").clientHeight || 0;

      if (heightContainer <= heightScreen) {
        await this.getNextArticle(false);
      }
    },

    containerScroll: async function ({target}) {
      if (this.isLoadNextArticle) {
        return null;
      }

      const containerHeight =
        document.getElementById("article-modal-height")?.clientHeight || 0;
      const scrollTop = target.scrollTop + window.innerHeight;

      if (this.isUpdateRouteScroll) {
        this.isUpdateRouteScroll = false;
        const lastArticle = this.articles[this.articles.length - 1];
        window.history.replaceState(null, null, `/aktsii/${lastArticle?.slug}`);
      }

      if (scrollTop >= containerHeight) {
        this.isLoadNextArticle = true;

        await this.getNextArticle();
      }
    },

    getNextArticle: async function (updateRoute = true) {
      this.isLoadNextArticle = true;
      this.$emit(
        "next",
        Number(this.articles[this.articles.length - 1]?.id),
        updateRoute
      );
    },

    setNextArticle: async function (article, updateRoute = true) {
      if (this.cancelNextArticles) {
        return
      }


      this.articles = [...this.articles, article];

      if (updateRoute) {
        const updateUrl = Boolean(this.route && this.route === "aktsii")
          ? `/aktsii/${article.slug}`
          : `${article.url}`;

        window.history.replaceState(null, null, updateUrl);
      } else {
        this.isUpdateRouteScroll = true;
      }

      setTimeout(() => {
        this.isLoadNextArticle = false;
      }, 3000);
    },

    onReplaceUrl: function (article, isVisible) {
      if (this.cancelNextArticles) {
        return
      }

      if (!isVisible) {
        return
      }

      const updateUrl = Boolean(this.route && this.route === "aktsii") ? `/aktsii/${article.slug}` : `${article.url}`;
      window.history.replaceState(null, null, `${updateUrl}${window.location.search}`);
    },
  },
});
